export const GET_CRM_ENQUIRY = "GET_CRM_ENQUIRY";
export const GET_CRM_ENQUIRY_SOURCE = "GET_CRM_ENQUIRY_SOURCE";
export const GET_CUSTOMER_BUDGET = "GET_CUSTOMER_BUDGET";
export const GET_CRM_DIMENSION = "GET_CRM_DIMENSION";
export const GET_CUSTOMER_CONSTRUCTIONS_PLANNING =
  "GET_CUSTOMER_CONSTRUCTIONS_PLANNING";
export const GET_CUSTOMER_PURCHASE_REASON = "GET_CUSTOMER_PURCHASE_REASON";
export const GET_CRM_SITE_SOLD = "GET_CRM_SITE_SOLD";
export const GET_CRM_CUSTOMER_ENQUIRY = "GET_CRM_CUSTOMER_ENQUIRY";
export const GET_CRM_ENQUIRY_PROFILE = "GET_CRM_ENQUIRY_PROFILE";
export const GET_CRM_ENQUIRY_PROFILE_EXPORT = "GET_CRM_ENQUIRY_PROFILE_EXPORT";
export const GET_SITE_VISIT_FEEDBACK_QUESTION =
  "GET_SITE_VISIT_FEEDBACK_QUESTION";
export const GET_SITE_VISIT_FEEDBACK = "GET_SITE_VISIT_FEEDBACK";
export const GET_SITE_VISIT_FEEDBACK_EXPORT = "GET_SITE_VISIT_FEEDBACK_EXPORT";
export const GET_SITE_VISIT_FEEDBACK_DETAIL = "GET_SITE_VISIT_FEEDBACK_DETAIL";
export const GET_CRM_BOOKING_ENQUIRY_PROFILE =
  "GET_CRM_BOOKING_ENQUIRY_PROFILE";
export const GET_CRM_MEETING = "GET_CRM_MEETING";
export const GET_CRM_MEETING_EXPORT = "GET_CRM_MEETING_EXPORT";
export const GET_CRM_MEETING_CATEGORY = "GET_CRM_MEETING_CATEGORY";
export const GET_CRM_MEETING_ATTENDEE = "GET_CRM_MEETING_ATTENDEE";
export const GET_CRM_MEETING_DETAIL = "GET_CRM_MEETING_DETAIL";
export const GET_CRM_MEETING_SOURCE = "GET_CRM_MEETING_SOURCE";
export const GET_CRM_MEETING_CHANNEL_PARTNER_INFO =
  "GET_CRM_MEETING_CHANNEL_PARTNER_INFO";
export const GET_CRM_MEETING_CHANNEL_CLIENT_INFO =
  "GET_CRM_MEETING_CHANNEL_CLIENT_INFO";
export const GET_CRM_MEETING_PREFERRED_LOCATION =
  "GET_CRM_MEETING_PREFERRED_LOCATION";
export const GET_CRM_MEETING_PREFERRED_LOCATION_EXPORT =
  "GET_CRM_MEETING_PREFERRED_LOCATION_EXPORT";
export const GET_CRM_MEETING_STM_INFO = "GET_CRM_MEETING_STM_INFO";
export const GET_CRM_SOURCE_GROUP = "GET_CRM_SOURCE_GROUP";
export const GET_CRM_SOURCE_GROUP_EXPORT = "GET_CRM_SOURCE_GROUP_EXPORT";
export const GET_CRM_SOURCE_CATEGORY = "GET_CRM_SOURCE_CATEGORY";
export const GET_CRM_SOURCE = "GET_CRM_SOURCE";
export const GET_CRM_ENQUIRY_STATUS = "GET_CRM_ENQUIRY_STATUS";
export const GET_CRM_ENQUIRY_CATEGORY = "GET_CRM_ENQUIRY_CATEGORY";
export const GET_CRM_ENQUIRY_CALL_STATUS = "GET_CRM_ENQUIRY_CALL_STATUS";
export const GET_DIMENSION_MASTER = "GET_DIMENSION_MASTER";
export const GET_RELEASE_STATUS = "GET_RELEASE_STATUS";
export const GET_CRM_SITE_PREMIUM_TYPE = "GET_CRM_SITE_PREMIUM_TYPE";
export const GET_CRM_SITE_STATUS = "GET_CRM_SITE_STATUS";
export const GET_SITE_INVESTOR = "GET_SITE_INVESTOR";
export const GET_BLOCK_REASON = "GET_BLOCK_REASON";
export const GET_ENQUIRY_FOLLOW_STATUS = "GET_ENQUIRY_FOLLOW_STATUS";

export const GET_CRM_CHANNEL_PARTNER = "GET_CRM_CHANNEL_PARTNER";
export const GET_CRM_CLIENT = "GET_CRM_CLIENT";
export const GET_CRM_STM = "GET_CRM_STM";
export const GET_CRM_MEETING_FILTER_PROJECT = "GET_CRM_MEETING_FILTER_PROJECT";
export const GET_CRM_MEETING_FILTER_HOSTED_BY =
  "GET_CRM_MEETING_FILTER_HOSTED_BY";
export const GET_FELLOW_UP = "GET_FELLOW_UP";
export const GET_FELLOW_UP_EXPORT = "GET_FELLOW_UP_EXPORT";
export const GET_CRM_FOLLOW_UP_FILTER_ASSIGNED_TO =
  "GET_CRM_FOLLOW_UP_FILTER_ASSIGNED_TO";
export const GET_CRM_ENQUIRY_FOLLOW_UP_REASON =
  "GET_CRM_ENQUIRY_FOLLOW_UP_REASON";
export const GET_CRM_SITE_FACE = "GET_CRM_SITE_FACE";
export const GET_CRM_CANCELLATION_REASON = "GET_CRM_CANCELLATION_REASON";

//promotional activity
export const GET_PROMOTIONAL_ACTIVITY = "GET_PROMOTIONAL_ACTIVITY";
export const GET_PROMOTIONAL_ACTIVITY_FILTER_PROJECT =
  "GET_PROMOTIONAL_ACTIVITY_FILTER_PROJECT";
export const CHECK_EXISTING_ENQUIRY = "CHECK_EXISTING_ENQUIRY";
export const GET_ACTIVITY_FOR_PROMOTIONAL_LEAD =
  "GET_ACTIVITY_FOR_PROMOTIONAL_LEAD";
export const GET_PROMOTIONAL_LEAD = "GET_PROMOTIONAL_LEAD";
export const GET_PROMOTIONAL_LEAD_EXPORT = "GET_PROMOTIONAL_LEAD_EXPORT";
export const GET_PROMOTIONAL_LEAD_FILTER_PROJECT =
  "GET_PROMOTIONAL_LEAD_FILTER_PROJECT";
export const GET_PROMOTIONAL_LEAD_FILTER_SOURCE =
  "GET_PROMOTIONAL_LEAD_FILTER_SOURCE";
export const GET_PROMOTIONAL_LEAD_FILTER_ACTIVITY =
  "GET_PROMOTIONAL_LEAD_FILTER_ACTIVITY";
export const GET_SOURCE_FOR_PROMOTIONAL_LEAD =
  "GET_SOURCE_FOR_PROMOTIONAL_LEAD";
export const GET_USER_FOR_PROMOTIONAL_LEAD = "GET_USER_FOR_PROMOTIONAL_LEAD";
export const GET_SUB_SOURCE_FOR_PROMOTIONAL_LEAD =
  "GET_SUB_SOURCE_FOR_PROMOTIONAL_LEAD";
export const GET_ENQUIRY_DETAIL_FOR_PROMOTIONAL_LEAD =
  "GET_ENQUIRY_DETAIL_FOR_PROMOTIONAL_LEAD";

//SITE VISIT
export const GET_LEAD_FOR_SITE_VISIT = "GET_LEAD_FOR_SITE_VISIT";
export const GET_LEAD_DETAIL_FOR_SITE_VISIT = "GET_LEAD_DETAIL_FOR_SITE_VISIT";
export const GET_SITE_VISIT = "GET_SITE_VISIT";

export const GET_EOI_PRICE = "GET_EOI_PRICE";
export const GET_EOI_PRICE_FILTER_PROJECT = "GET_EOI_PRICE_FILTER_PROJECT";
export const GET_EOI_PRICE_FILTER_DIMENSION = "GET_EOI_PRICE_FILTER_DIMENSION";
export const GET_EXPRESSION_OF_INTEREST = "GET_EXPRESSION_OF_INTEREST";
export const GET_EXPRESSION_OF_INTEREST_EXPORT =
  "GET_EXPRESSION_OF_INTEREST_EXPORT";
export const GET_CUSTOMER_INFO = "GET_CUSTOMER_INFO";
export const GET_EXPRESSION_OF_INTEREST_DETAIL =
  "GET_EXPRESSION_OF_INTEREST_DETAIL";
export const GET_EXPRESSION_OF_INTEREST_FILTER_PROJECT =
  "GET_EXPRESSION_OF_INTEREST_FILTER_PROJECT";
export const GET_EOI_PRICE_DETAIL = "GET_EOI_PRICE_DETAIL";
export const GET_COMPANY_FOR_CRM_PROJECT = "GET_COMPANY_FOR_CRM_PROJECT";
export const GET_EOI_PAYMENT_DETAIL = "GET_EOI_PAYMENT_DETAIL";
export const GET_SITE_FACING = "GET_SITE_FACING";

// Customer Ticket //
export const GET_CUSTOMER_TICKET = "GET_CUSTOMER_TICKET";
export const GET_CUSTOMER_TICKET_FOR_SITE = "GET_CUSTOMER_TICKET_FOR_SITE";
export const GET_USER_TICKET_FILTER = "GET_USER_TICKET_FILTER";
export const GET_CUSTOMER_TICKET_FOR_ASSINGNED_USER =
  "GET_CUSTOMER_TICKET_FOR_ASSINGNED_USER";
export const GET_CUSTOMER_TICKET_EXPORT = "GET_CUSTOMER_TICKET_EXPORT";
export const GET_TICKET_FOLLOW_UP = "GET_TICKET_FOLLOW_UP";
export const GET_CUSTOMER_TICKET_DETAIL = "GET_CUSTOMER_TICKET_DETAIL";
export const GET_PROJECT_TICKET_FILTER = "GET_PROJECT_TICKET_FILTER";
export const GET_CUSTOMER_TICKET_STATUS = "GET_CUSTOMER_TICKET_STATUS";
export const GET_CUSTOMER_TICKET_CATEGORY = "GET_CUSTOMER_TICKET_CATEGORY";
export const GET_CUSTOMER_TICKET_CATEGORY_EXPORT =
  "GET_CUSTOMER_TICKET_CATEGORY_EXPORT";
export const GET_CUSTOMER_TICKET_FILTER_STATUS =
  "GET_CUSTOMER_TICKET_FILTER_STATUS";
export const GET_CATEGORY_FOR_TICKET = "GET_CATEGORY_FOR_TICKET";
// Site Visit Completed
export const GET_SITE_VISIT_COMPLETED = "GET_SITE_VISIT_COMPLETED";
export const GET_SITE_VISIT_COMPLETED_FILTER_PROJECT =
  "GET_SITE_VISIT_COMPLETED_FILTER_PROJECT";
export const GET_ITEM_FOR_TRAVEL_BILL = "GET_ITEM_FOR_TRAVEL_BILL";
export const GET_TRAVEL_BILL_DETAILS = "GET_TRAVEL_BILL_DETAILS";
export const GET_COUNTRY_CODE = "GET_COUNTRY_CODE";

//CRM Masters
//project premium cost
export const GET_PROJECT_PREMIUM_COST = "GET_PROJECT_PREMIUM_COST";
export const CREATE_PROJECT_PREMIUM_COST = "CREATE_PROJECT_PREMIUM_COST";
export const UPDATE_PROJECT_PREMIUM_COST = "UPDATE_PROJECT_PREMIUM_COST";
export const GET_PROJECT_PREMIUM_COST_EXPORT =
  "GET_PROJECT_PREMIUM_COST_EXPORT";
export const GET_PROJECT_PREMIUM_COST_FILTER_PROJECT =
  "GET_PROJECT_PREMIUM_COST_FILTER_PROJECT";
export const GET_PROJECT_PREMIUM_COST_FILTER_PREMIUM_TYPE =
  "GET_PROJECT_PREMIUM_COST_FILTER_PREMIUM_TYPE";

//Readiness Checklist
export const GET_READINESS_CHECKLIST = "GET_READINESS_CHECKLIST";
export const CREATE_READINESS_CHECKLIST = "CREATE_READINESS_CHECKLIST";
export const UPDATE_READINESS_CHECKLIST = "UPDATE_READINESS_CHECKLIST";
export const GET_READINESS_CHECKLIST_EXPORT = "GET_READINESS_CHECKLIST_EXPORT";
// Site Investor
export const GET_SITE_INVESTORS = "GET_SITE_INVESTORS";
export const CREATE_SITE_INVESTORS = "CREATE_SITE_INVESTORS";
export const GET_SITE_INVESTORS_EXPORT = "GET_SITE_INVESTORS_EXPORT";
// Delay Reason
export const GET_DELAY_REASON = "GET_DELAY_REASON";
export const CREATE_DELAY_REASON = "CREATE_DELAY_REASON";
export const GET_DELAY_REASON_EXPORT = "GET_DELAY_REASON_EXPORT";
//Site TDS
export const GET_SITE_TDS = " GET_SITE_TDS";
export const CREATE_SITE_TDS = "CREATE_SITE_TDS";
export const UPDATE_SITE_TDS = "UPDATE_SITE_TDS";
export const GET_TDS_SECTION = "GET_TDS_SECTION";
export const GET_SITE_TDS_EXPORT = "GET_SITE_TDS_EXPORT";
export const GET_SITE_TDS_DETAIL = "GET_SITE_TDS_DETAIL";
export const GET_SITE_TDS_FILTER_SECTION = "GET_SITE_TDS_FILTER_SECTION";

// Site Cost
export const GET_SITE_COST = "GET_SITE_COST";
export const GET_SITE_COST_EXPORT = "GET_SITE_COST_EXPORT";
export const GET_SITE_COST_FILTER_PROJECT = "GET_SITE_COST_FILTER_PROJECT";
//Registration Cost
export const GET_REGISTRATION_COST = "GET_REGISTRATION_COST";
export const GET_REGISTRATION_COST_EXPORT = "GET_REGISTRATION_COST_EXPORT";

//sushil start
// CRM Source Category
export const GET_SOURCE_CATEGORY = "GET_SOURCE_CATEGORY";
export const GET_SOURCE_CATEGORY_EXPORT = "GET_SOURCE_CATEGORY_EXPORT";
// CRM Source
export const GET_SOURCE = "GET_SOURCE";
export const GET_SOURCE_EXPORT = "GET_SOURCE_EXPORT";
// CRM Sub Source
export const GET_SUB_SOURCE = "GET_SUB_SOURCE";
export const GET_SUB_SOURCE_EXPORT = "GET_SUB_SOURCE_EXPORT";
// CRM Reason
export const GET_REASON = "GET_REASON";
export const GET_REASON_EXPORT = "GET_REASON_EXPORT";
// CRM Dimensions
export const GET_DIMENSION = "GET_DIMENSION";
export const GET_DIMENSION_EXPORT = "GET_DIMENSION_EXPORT";
// CRM Site Face
export const GET_SITE_FACE = "GET_SITE_FACE";
export const GET_SITE_FACE_EXPORT = "GET_SITE_FACE_EXPORT";
// CRM Site Premium Type
export const GET_SITE_PREMIUM_TYPE = "GET_SITE_PREMIUM_TYPE";
export const GET_SITE_PREMIUM_TYPE_EXPORT = "GET_SITE_PREMIUM_TYPE_EXPORT";
// CRM Lead Status
export const GET_LEAD_STATUS = "GET_LEAD_STATUS";
export const GET_LEAD_STATUS_EXPORT = "GET_LEAD_STATUS_EXPORT";
// CRM Release Status
export const GET_RELEASE_STATUS_NEW = "GET_RELEASE_STATUS_NEW";
export const GET_RELEASE_STATUS_NEW_EXPORT = "GET_RELEASE_STATUS_NEW_EXPORT";
// CRM Site Status
export const GET_SITE_STATUS = "GET_SITE_STATUS";
export const GET_SITE_STATUS_EXPORT = "GET_SITE_STATUS_EXPORT";
// CRM Cancellation Reason
export const GET_CANCELLATION_REASON = "GET_CANCELLATION_REASON";
export const GET_CANCELLATION_REASON_EXPORT = "GET_CANCELLATION_REASON_EXPORT";
// CRM Block Reason
export const GET_BLOCK_REASON_NEW = "GET_BLOCK_REASON_NEW";
export const GET_BLOCK_REASON_NEW_EXPORT = "GET_BLOCK_REASON_NEW_EXPORT";
// CRM Other Charges
export const GET_OTHER_CHARGES = "GET_OTHER_CHARGES";
export const GET_OTHER_CHARGES_EXPORT = "GET_OTHER_CHARGES_EXPORT";
// CRM Other Project Charge Map
export const GET_PROJECT_OTHER_CHARGE_MAP = "GET_PROJECT_OTHER_CHARGE_MAP";
export const GET_PROJECT_OTHER_CHARGE_MAP_EXPORT =
  "GET_PROJECT_OTHER_CHARGE_MAP_EXPORT";
export const GET_PROJECT_OTHER_CHARGE_DETAIL =
  "GET_PROJECT_OTHER_CHARGE_DETAIL";
export const GET_PROJECT_OTHER_CHARGE_DETAIL_FILTER_PROJECT =
  "GET_PROJECT_OTHER_CHARGE_DETAIL_FILTER_PROJECT";
// CRM Lead Category
export const GET_LEAD_CATEGORY = "GET_LEAD_CATEGORY";
export const GET_LEAD_CATEGORY_EXPORT = "GET_LEAD_CATEGORY_EXPORT";
// Crm Lead Constraint
export const GET_CRM_LEAD_CONSTRAINT = "GET_CRM_LEAD_CONSTRAINT";
export const GET_CRM_LEAD_CONSTRAINT_EXPORT = "GET_CRM_LEAD_CONSTRAINT_EXPORT";
// CRM Call Status
export const GET_CALL_STATUS = "GET_CALL_STATUS";
export const GET_CALL_STATUS_EXPORT = "GET_CALL_STATUS_EXPORT";
// CRM Unqualified Reason
export const GET_UNQUALIFIED_REASON = "GET_UNQUALIFIED_REASON";
export const GET_UNQUALIFIED_REASON_EXPORT = "GET_UNQUALIFIED_REASON_EXPORT";
// CRM Project Discount
export const GET_SITE_DISCOUNT = "GET_SITE_DISCOUNT";
export const GET_SITE_DISCOUNT_EXPORT = "GET_SITE_DISCOUNT_EXPORT";

//Customer Contact Type
export const GET_CUSTOMER_CONTACT_TYPE = "GET_CUSTOMER_CONTACT_TYPE";
export const GET_CUSTOMER_CONTACT_TYPE_EXPORT =
  "GET_CUSTOMER_CONTACT_TYPE_EXPORT";
// Customer Contact
export const GET_CUSTOMER_CONTACT = "GET_CUSTOMER_CONTACT";
export const GET_CUSTOMER_CONTACT_EXPORT = "GET_CUSTOMER_CONTACT_EXPORT";
export const GET_CUSTOMER_CONTACT_FILTER_PROJECT =
  "GET_CUSTOMER_CONTACT_FILTER_PROJECT";
export const GET_CUSTOMER_CONTACT_FILTER_CONTACT_TYPE =
  "GET_CUSTOMER_CONTACT_FILTER_CONTACT_TYPE";
//Customer Feedback
export const GET_CUSTOMER_FEEDBACK = "GET_CUSTOMER_FEEDBACK";
export const GET_CUSTOMER_FEEDBACK_EXPORT = "GET_CUSTOMER_FEEDBACK_EXPORT";
export const GET_CUSTOMER_FEEDBACK_FILTER_PROJECT =
  "GET_CUSTOMER_FEEDBACK_FILTER_PROJECT";
//  Project Progress
export const GET_PROJECT_PROGRESS = "GET_PROJECT_PROGRESS";
export const GET_PROJECT_PROGRESS_EXPORT = "GET_PROJECT_PROGRESS_EXPORT";
export const GET_PROJECT_PROGRESS_FILTER_PROJECT =
  "GET_PROJECT_PROGRESS_FILTER_PROJECT";
export const GET_PROJECT_PROGRESS_DETAIL = "GET_PROJECT_PROGRESS_DETAIL";
//sushil end
// clp start
//construction link
export const GET_CONSTRUCTION_LINK_PAYMENT = "GET_CONSTRUCTION_LINK_PAYMENT";
export const GET_CONSTRUCTION_LINK_PAYMENT_EXPORT =
  "GET_CONSTRUCTION_LINK_PAYMENT_EXPORT";
export const GET_PROJECT_CLP_PLAN = "GET_PROJECT_CLP_PLAN";
export const GET_PROJECT_CLP_PLAN_EXPORT = "GET_PROJECT_CLP_PLAN_EXPORT";
export const GET_PROJECT_CLP_PLAN_DETAILS = "GET_PROJECT_CLP_PLAN_DETAILS";
export const GET_ITEM_FOR_PROJECR_PLAN_CLP = "GET_ITEM_FOR_PROJECR_PLAN_CLP";
export const GET_PROJECT_CLP_PLAN_FILTER_PROJECT =
  "GET_PROJECT_CLP_PLAN_FILTER_PROJECT";
export const GET_PROJECT_CLP_PLAN_FILTER_BANK =
  "GET_PROJECT_CLP_PLAN_FILTER_BANK";
export const GET_PROJECT_FROM_CLP_PLAN = "GET_PROJECT_FROM_CLP_PLAN";
export const GET_BANK_FROM_CLP_PLAN = "GET_BANK_FROM_CLP_PLAN";
export const GET_MILESTONE_FORM_CLP_PLAN = "GET_MILESTONE_FORM_CLP_PLAN";
//clp payment schedule
export const GET_CLP_PAYMENT_SCHEDULE = "GET_CLP_PAYMENT_SCHEDULE";
export const GET_CLP_PAYMENT_SCHEDULE_EXPORT =
  "GET_CLP_PAYMENT_SCHEDULE_EXPORT";
export const GET_CLP_PAYMENT_SCHEDULE_FILTER_PROJECT =
  "GET_CLP_PAYMENT_SCHEDULE_FILTER_PROJECT";
export const GET_CLP_PAYMENT_SCHEDULE_FILTER_STATUS =
  "GET_CLP_PAYMENT_SCHEDULE_FILTER_STATUS";
export const GET_CLP_PAYMENT_SCHUDULE_DETAIL =
  "GET_CLP_PAYMENT_SCHUDULE_DETAIL";
export const GET_CLP_PAYMENT_SCHEDULE_FILTER_SITE =
  "GET_CLP_PAYMENT_SCHEDULE_FILTER_SITE";
export const GET_PAYMENT_DELAY_REASON = "GET_PAYMENT_DELAY_REASON";
export const GET_PAYMENT_RECEIPT_PRINT = "GET_PAYMENT_RECEIPT_PRINT";
export const GET_PAYMENT_DEMAND_FILTER_MILESTONE =
  "GET_PAYMENT_DEMAND_FILTER_MILESTONE";
// clp demand
export const GET_PROJECT_FOR_CLP_PLAN = "GET_PROJECT_FOR_CLP_PLAN";
export const GET_SITE_FOR_CLP_PLAN = "GET_SITE_FOR_CLP_PLAN";
export const GET_MILESTONE_FOR_DEMAND_NOTE = "GET_MILESTONE_FOR_DEMAND_NOTE";
export const GET_CLP_DEMAND_NOTE = "GET_CLP_DEMAND_NOTE";
export const GET_CLP_DEMAND_NOTE_EXPORT = "GET_CLP_DEMAND_NOTE_EXPORT";
export const GET_PROJECT_FOR_CLP_DEMAND_NOTE =
  "GET_PROJECT_FOR_CLP_DEMAND_NOTE";
export const GET_CLP_DEMAND_NOTE_FILTER_STATUS =
  "GET_CLP_DEMAND_NOTE_FILTER_STATUS";
export const GET_CLP_DEMAND_NOTE_DETAILS = "GET_CLP_DEMAND_NOTE_DETAILS";
export const GET_MILESTONE_FOR_DEMAND_NOTE_RECEIVED =
  "GET_MILESTONE_FOR_DEMAND_NOTE_RECEIVED";
export const GET_PAYMENT_DEMAND_FILTER_CRM_USER =
  "GET_PAYMENT_DEMAND_FILTER_CRM_USER";
export const GET_PAYMENT_DEMAND_FILTER_SITE_NUMBER =
  "GET_PAYMENT_DEMAND_FILTER_SITE_NUMBER";
export const GET_PAYMENT_DEMAND_FILTER_SITE_STATUS =
  "GET_PAYMENT_DEMAND_FILTER_SITE_STATUS";
export const GET_PAYMENT_SCHEDULE_FILTER_CRM_USER =
  "GET_PAYMENT_SCHEDULE_FILTER_CRM_USER";
export const GET_PAYMENT_SCHEDULE_FILTER_MILESTONE =
  "GET_PAYMENT_SCHEDULE_FILTER_MILESTONE";

// clp end

//Company Resolution
export const GET_PROJECT_FOR_COMPANY_RESOLUTION =
  "GET_PROJECT_FOR_COMPANY_RESOLUTION";
export const GET_COMPANY_RESOLUTION = "GET_COMPANY_RESOLUTION";
export const GET_COMPANY_RESOLUTION_DETAIL = "GET_COMPANY_RESOLUTION_DETAIL";
export const GET_COMPANY_RESOLUTION_FILTER_PROJECT =
  "GET_COMPANY_RESOLUTION_FILTER_PROJECT";
export const GET_COMPANY_RESOLUTION_FILTER_COMPANY =
  "GET_COMPANY_RESOLUTION_FILTER_COMPANY";

//site authority
export const GET_SITE_FOR_COMPANY_AUTHORIZATION =
  "GET_SITE_FOR_COMPANY_AUTHORIZATION";
export const GET_REPRESENTATIVE_FOR_COMPANY_AUTHORIZATION =
  "GET_REPRESENTATIVE_FOR_COMPANY_AUTHORIZATION";
export const GET_DIRECTOR_FOR_COMPANY_AUTHORIZATION =
  "GET_DIRECTOR_FOR_COMPANY_AUTHORIZATION";
export const GET_COMPANY_AUTHORIZATION = "GET_COMPANY_AUTHORIZATION";
export const GET_COMPANY_AUTHORIZATION_FILTER_PROJECT =
  "GET_COMPANY_AUTHORIZATION_FILTER_PROJECT";
export const GET_COMPANY_AUTHORIZATION_FILTER_REPRESENTATIVE =
  "GET_COMPANY_AUTHORIZATION_FILTER_REPRESENTATIVE";
export const GET_COMPANY_AUTHORIZATION_FILTER_DIRECTOR =
  "GET_COMPANY_AUTHORIZATION_FILTER_DIRECTOR";
export const GET_COMPANY_AUTHORIZATION_FILTER_COMPANY =
  "GET_COMPANY_AUTHORIZATION_FILTER_COMPANY";
export const GET_COMPANY_AUTHORIZATION_DETAIL =
  "GET_COMPANY_AUTHORIZATION_DETAIL";
export const GET_DIRECTOR_FOR_COMPANY_RESOLUTION =
  "GET_DIRECTOR_FOR_COMPANY_RESOLUTION";

//Mortgage NOC
export const GET_MORTGAGE_NOC = "GET_MORTGAGE_NOC";
export const GET_MORTGAGE_NOC_EXPORT = "GET_MORTGAGE_NOC_EXPORT";
export const CREATE_GET_MORTGAGE_NOC = "CREATE_GET_MORTGAGE_NOC";
export const UPDATE_GET_MORTGAGE_NOC = "UPDATE_GET_MORTGAGE_NOC";
export const GET_MORTGAGE_NOC_TEMPLATE = "GET_MORTGAGE_NOC_TEMPLATE";
export const GET_MORTGAGE_NOC_PROJECT_FILTER =
  "GET_MORTGAGE_NOC_PROJECT_FILTER";
export const GET_MORTGAGE_NOC_ACCOUNTABLE_FILTER =
  "GET_MORTGAGE_NOC_ACCOUNTABLE_FILTER";
export const GET_MORTGAGE_NOC_RESPONSIBLE_FILTER =
  "GET_MORTGAGE_NOC_RESPONSIBLE_FILTER";
export const GET_MORTGAGE_NOC_FILTER_PREMIUM_TYPE =
  "GET_MORTGAGE_NOC_FILTER_PREMIUM_TYPE";
export const GET_MORTGAGE_NOC_DETAIL = "GET_MORTGAGE_NOC_DETAIL";
export const GET_MORTGAGE_NOC_PRINT = "GET_MORTGAGE_NOC_PRINT";

//Payment NOC
export const GET_PAYMENT_NOC = "GET_PAYMENT_NOC";
export const GET_PAYMENT_NOC_FILTER_PROJECT = "GET_PAYMENT_NOC_FILTER_PROJECT";
export const GET_PAYMENT_NOC_FILTER_ACCOUNTABLE =
  "GET_PAYMENT_NOC_FILTER_ACCOUNTABLE";
export const GET_PAYMENT_NOC_FILTER_RESPONSIBLE =
  "GET_PAYMENT_NOC_FILTER_RESPONSIBLE";
export const GET_PAYMENT_NOC_EXPORT = "GET_PAYMENT_NOC_EXPORT";
export const GET_PAYMENT_NOC_DETAIL = "GET_PAYMENT_NOC_DETAIL";

//Legal File Request
export const GET_SALES_BOOKING_LEGAL_FILE_REQUEST =
  "getSalesBookingLegalFileRequest";
export const GET_SALES_ORDER_LEGAL_FILE_REQUEST_EXPORT =
  "getSalesBookingLegalFileRequestExport";
export const GET_SALES_BOOKING_LEGAL_FILE_REQUEST_DETAIL =
  "getSalesBookingLegalFileRequestDetail";
export const DELETE_CRM_SALES_DOCUMENT = "deleteCrmSalesDocument";
export const GET_SALES_BOOKING_LEGAL_FILE_REQUEST_FILTER_PROJECT =
  "getSalesBookingLegalFileRequestFilterProject";
export const GET_SALES_BOOKING_LEGAL_FILE_REQUEST_FILTER_ACCOUNTABLE =
  "getSalesBookingLegalFileRequestFilterAccountable";
export const GET_SALES_BOOKING_LEGAL_FILE_REQUEST_FILTER_RESPONSIBLE =
  "getSalesBookingLegalFileRequestFilterResponsible";

//tally info
export const GET_TALLY_INFO = "GET_TALLY_INFO";
//loan dependency
export const GET_SITE_FILTER_PROJECT = "GET_SITE_FILTER_PROJECT";
export const GET_SITE = "GET_SITE";

//First Party Katha Transfer
export const GET_SALES_BOOKING_FIRST_PARTY_REQUEST =
  "GET_SALES_BOOKING_FIRST_PARTY_REQUEST";
export const GET_SALES_BOOKING_FIRST_PARTY_REQUEST_FILTER_PROJECT =
  "GET_SALES_BOOKING_FIRST_PARTY_REQUEST_FILTER_PROJECT";
export const GET_SALES_BOOKING_FIRST_PARTY_REQUEST_FILTER_RESPONSIBLE =
  "GET_SALES_BOOKING_FIRST_PARTY_REQUEST_FILTER_RESPONSIBLE";
export const GET_SALES_BOOKING_FIRST_PARTY_REQUEST_FILTER_ACCOUNTABLE =
  "GET_SALES_BOOKING_FIRST_PARTY_REQUEST_FILTER_ACCOUNTABLE";
export const GET_SALES_BOOKING_FIRST_PARTY_REQUEST_DETAIL =
  "GET_SALES_BOOKING_FIRST_PARTY_REQUEST_DETAIL";
export const GET_SALES_BOOKING_FIRST_PARTY_REQUEST_EXPORT =
  "GET_SALES_BOOKING_FIRST_PARTY_REQUEST_EXPORT";

// ec-request
export const GET_SALES_BOOKING_EC = "getSalesBookingEC";
export const GET_SALES_BOOKING_EC_DETAIL = "getSalesBookingECDetail";
export const GET_SALES_BOOKING_EC_REQUEST_EXPORT =
  "getSalesBookingECRequestExport";
export const GET_SALES_BOOKING_EC_FILTER_PROJECT =
  "getSalesBookingECFilterProject";
export const GET_SALES_BOOKING_EC_FILTER_ACCOUNTABLE =
  "getSalesBookingECFilterAccountable";
export const GET_SALES_BOOKING_EC_FILTER_RESPONSIBLE =
  "getSalesBookingECFilterResponsible";

//Stone Marking
export const GET_SALES_BOOKING_STONE_MARKING =
  "GET_SALES_BOOKING_STONE_MARKING";
export const GET_SALES_BOOKING_STONE_MARKING_FILTER_PROJECT =
  "GET_SALES_BOOKING_STONE_MARKING_FILTER_PROJECT";
export const GET_SALES_BOOKING_STONE_MARKING_FILTER_RESPONSIBLE =
  "GET_SALES_BOOKING_STONE_MARKING_FILTER_RESPONSIBLE";
export const GET_SALES_BOOKING_STONE_MARKING_FILTER_ACCOUNTABLE =
  "GET_SALES_BOOKING_STONE_MARKING_FILTER_ACCOUNTABLE";
export const GET_SALES_BOOKING_STONE_MARKING_EXPORT =
  "GET_SALES_BOOKING_STONE_MARKING_EXPORT";
export const GET_SALES_BOOKING_STONE_MARKING_DETAIL =
  "GET_SALES_BOOKING_STONE_MARKING_DETAIL";

// Stamp Duty
export const GET_SALE_BOOKING_ESTAMP = "GET_SALE_BOOKING_ESTAMP";
export const GET_SALE_BOOKING_ESTAMP_DETAIL = "GET_SALE_BOOKING_ESTAMP_DETAIL";
export const GET_SALE_BOOKING_ESTAMP_FILTER_PROJECT =
  "GET_SALE_BOOKING_ESTAMP_FILTER_PROJECT";
export const GET_SALE_BOOKING_ESTAMP_FILTER_RESPONSIBLE =
  "GET_SALE_BOOKING_ESTAMP_FILTER_RESPONSIBLE";
export const GET_SALE_BOOKING_ESTAMP_FILTER_ACCOUNTABLE =
  "GET_SALE_BOOKING_ESTAMP_FILTER_ACCOUNTABLE";
export const GET_SALE_BOOKING_ESTAMP_EXPORT = "GET_SALE_BOOKING_ESTAMP_EXPORT";
